import classNames from "classnames";
import {
  type ButtonHTMLAttributes,
  forwardRef,
  type ReactNode,
  type Ref,
} from "react";
import { BaseButton } from "../Button/BaseButton.tsx";
import { Icon, type IconName } from "../Icon/Icon.tsx";
import { Spinner } from "../Spinner/Spinner.tsx";

export const DropdownItem = forwardRef(
  (
    {
      children,
      loading,
      loadingContent,
      disabled,
      active,
      type = "button",
      size = "md",
      leftIconName,
      rightIconName,
      className,
      ...rest
    }: {
      children?: ReactNode;
      loading?: boolean;
      active?: boolean;
      loadingContent?: ReactNode;
      size?: "sm" | "md";
      leftIconName?: IconName;
      rightIconName?: IconName;
    } & ButtonHTMLAttributes<HTMLButtonElement>,
    ref: Ref<HTMLButtonElement>,
  ) => (
    <BaseButton
      ref={ref}
      type={type}
      disabled={!!disabled || loading}
      loading={loading}
      loadingContent={loadingContent ?? <Spinner size={size} />}
      className={classNames(
        "flex-row items-center gap-200 px-200 py-100 rounded-150 label-md-default enabled:active:bg-surface-primary-active",
        disabled ? "text-disabled" : "text-primary",
        active
          ? "enabled:bg-surface-primary-active"
          : "bg-surface-primary-rest enabled:hover:bg-surface-primary-hover",
        size === "sm" ? "h-600" : "h-800",
        className,
      )}
      {...rest}
    >
      {leftIconName && <Icon name={leftIconName} size="sm" />}
      <div className="flex-fill flex-row items-center">{children}</div>
      {rightIconName && (
        <Icon
          name={rightIconName}
          size="sm"
          className="stroke-secondary-rest"
        />
      )}
    </BaseButton>
  ),
);
